export default [
  {
    path: '/',
    name: 'guide',
    component: () => import('@/views/LoginPage/guide')
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import('@/views/LoginPage/welcome')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginPage/login')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/LoginPage/register')
  },
  {
    path: '/forget',
    name: 'forget',
    component: () => import('@/views/LoginPage/forget')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/HomePage')
  },
  {
    path: '/setup',
    name: 'setup',
    component: () => import('@/views/HomePage/modules/Setup')
  },
  {
    path: '/statistics',
    name: 'statistics',
    component: () => import('@/views/StatisticsPage')
  },
  {
    path: '/history',
    name: 'history',
    component: () => import('@/views/StatisticsPage/modules/History')
  },
  {
    path: '/mine',
    name: 'mine',
    component: () => import('@/views/MinePage')
  },
  {
    path: '/message',
    name: 'message',
    component: () => import('@/views/MinePage/modules/Message')
  },
  {
    path: '/messageDetail',
    name: 'messageDetail',
    component: () => import('@/views/MinePage/modules/MessageDetail')
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('@/views/MinePage/modules/Help')
  },
  {
    path: '/manual',
    name: 'manual',
    component: () => import('@/views/MinePage/modules/Manual')
  },
  {
    path: '/helpDetail',
    name: 'helpDetail',
    component: () => import('@/views/MinePage/modules/HelpDetail')
  },
  {
    path: '/manualDetail',
    name: 'manualDetail',
    component: () => import('@/views/MinePage/modules/ManualDetail')
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('@/views/MinePage/modules/Feedback')
  },
  {
    path: '/favorite',
    name: 'favorite',
    component: () => import('@/views/MinePage/modules/Favorite')
  },
  {
    path: '/setting',
    name: 'setting',
    component: () => import('@/views/MinePage/modules/Setting')
  },
  {
    path: '/sites',
    name: 'sites',
    component: () => import('@/views/MinePage/modules/Sites')
  },
  {
    path: '/information',
    name: 'information',
    component: () => import('@/views/MinePage/modules/Information')
  },
  {
    path: '/iframeWithBar',
    name: 'iframeWithBar',
    component: () => import('@/views/MinePage/modules/IframeWithBar')
  },
]
